import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import CloseIcon from "@material-ui/icons/Close";
import _ from "lodash";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
    getFallbackItemPicture,
    getFilteredLineItemName,
    getFilteredLineItemVariant,
    getItemPicture,
    isDeviceProtectionSku,
    isEgiftcardSku,
    isShippingProtectionSku
} from "../Helpers/OderUtils";
import "../Styles/_OrderPopupWindow.css";
import "../Styles/_ReturnOrderItemsWindow.css";
import ConfirmationWindow from "./_ConfirmationWindow";
import DataConflictWindow from "./_DataConflictWindow";
import { Confirmed } from "./_Icon";

let scrolled_into_view = false;

export class ReturnOrderItemsWindow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            returnItems: [],
            returnReasonId: null,
            returnErrorMessage: "",
            itemsAvailableForReturn: [],
            returnFinished: false,
            submitErrors: [],
            confirmationWindowOpen: false,
            dataConflictWindowOpen: false
        };
        scrolled_into_view = false;
    }

    componentDidMount() {
        const itemsAvailableForReturn = [];

        this.props.order.sub_orders.forEach(so => {
            so.line_items.forEach(line_item => {
                if (
                    line_item.fulfillable_quantity < line_item.quantity &&
                    line_item.requires_shipping &&
                    !isShippingProtectionSku(line_item.sku) &&
                    !isEgiftcardSku(line_item.sku) &&
                    !isDeviceProtectionSku(line_item.sku)
                ) {
                    const lineItem = { ...line_item };
                    itemsAvailableForReturn.push(lineItem);
                }
            });
        });

        this.setState({
            itemsAvailableForReturn
        });

        this.scrollWindowIntoView();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.loading === false && prevProps.loading === true) {
            if (!this.props.err) {
                this.resetErrorMessages();
                this.setState({
                    returnFinished: true
                });
            } else {
                this.setState({
                    returnErrorMessage: this.props.currentLanguage.ORDER_PAGE.RETURN_SECTION.RETURN_ORDER_ITEMS.ERROR_FAILED
                });
            }
        }

        if (this.props.returnOrderCalculating === false && prevProps.returnOrderCalculating === true) {
            if (this.props.returnOrderCalculatingError) {
                this.setState({
                    returnErrorMessage: this.props.currentLanguage.ORDER_PAGE.RETURN_SECTION.RETURN_ORDER_ITEMS.ERROR_CALCULATION_FAILED
                });
            } else {
                this.resetErrorMessages();
            }
        }

        if (
            (prevProps.returnOrderCalculating === true &&
                this.props.returnOrderCalculating === false &&
                this.props.returnOrderCalculatingError === "conflict") ||
            (prevProps.loading === true && this.props.loading === false && this.props.err === "conflict")
        ) {
            this.setState({
                dataConflictWindowOpen: true
            });
        }

        if (prevProps.open === false && this.props.open === true && this.props.returnReasons.length === 0 && this.props.returnReasonsLoading === false) {
            this.props.getReturnReasons();
        }

        if (prevProps.open === false && this.props.open === true) {
            this.resetErrorMessages();
            this.resetReturnReason();
            this.resetReturnItems();
            this.resetReturnFinished();
            this.props.returnOrderCalculateReset();
            this.resetSubmitErrors();
            scrolled_into_view = false;
        }

        if (JSON.stringify(prevState.returnItems) !== JSON.stringify(this.state.returnItems)) {
            this.props.returnOrderCalculate(this.props.match.params.order_id, {
                order: this.props.order,
                items: this.state.returnItems
            });
        }
    }

    scrollWindowIntoView = () => {
        const element = document.getElementById("return-order-items-window");

        if (element && !scrolled_into_view) {
            element.scrollIntoView({
                behavior: "auto",
                block: "start",
                inline: "center"
            });
            scrolled_into_view = true;

            this.postMessageToParentWindow();
        }
    };

    postMessageToParentWindow = () => {
        const data = {
            action: "DIALOG_WINDOW_OPEN"
        };

        window.parent.window.postMessage(JSON.stringify(data), "*");
    };

    resetReturnFinished = () => {
        this.setState({ returnFinished: false });
    };

    handleNoClick = () => {
        if (this.state.returnFinished) {
            this.props.handleClose();
            this.props.getOrder(this.props.order_id);
        } else {
            this.props.handleClose();
        }
    };

    handleYesClick = () => {
        this.resetSubmitErrors();
        const errors = this.getSubmitErrors();
        if (errors.length === 0) {
            this.handleOpenConfirmationWindow();
        } else {
            this.setState({ submitErrors: errors });
        }
    };

    handleConfirmReturnOrder = () => {
        this.resetErrorMessages();
        this.handleCloseConfirmationWindow();
        this.returnOrder();
    };

    returnOrder = () => {
        this.props.returnOrder(
            this.props.order_id,
            {
                order: this.props.order,
                items: this.state.returnItems,
                reason: this.state.returnReasonId
            },
            this.props.language
        );
    };

    getSubmitErrors = () => {
        const errors = [];
        const returnSection = this.props.currentLanguage.ORDER_PAGE.RETURN_SECTION;

        if (!this.state.returnReasonId) {
            errors.push({
                code: "return_reason",
                label: returnSection.ERRORS.REASON_REQUIRED
            });
        }

        if (this.state.returnItems.length === 0) {
            errors.push({
                code: "return_items",
                label: returnSection.RETURN_ORDER_ITEMS.ERRORS.CANCEL_ITEMS_REQUIRED
            });
        }

        return errors;
    };

    resetSubmitErrors = () => {
        this.setState({ submitErrors: [] });
    };

    resetErrorMessages = () => {
        this.setState({ returnErrorMessage: "" });
    };

    handleReturnItemQuantityChange = (lineItem, e) => {
        if (this.props.returnOrderCalculating || this.props.loading || isNaN(e.target.value) || Number(e.target.value) < 0) {
            return;
        }

        const value = Number(e.target.value);
        const maxQuantity = lineItem.quantity - lineItem.fulfillable_quantity;
        const newQuantity = Math.min(value, maxQuantity);
        let returnItems = [...this.state.returnItems];
        const existingItem = returnItems.find(i => i.lineItemId === lineItem.line_item_id);

        if (value === 0) {
            returnItems = returnItems.filter(i => i.lineItemId !== lineItem.line_item_id);
        } else if (existingItem) {
            existingItem.quantity = newQuantity;
        } else {
            returnItems.push({
                lineItemId: lineItem.line_item_id,
                quantity: newQuantity
            });
        }

        this.setState({ returnItems });
    };

    handleChange = e => {
        if (e.target.name === "return-reason") {
            this.setState({ returnReasonId: e.target.value });
        }
    };

    resetReturnReason = () => {
        this.setState({ returnReasonId: null });
    };

    resetReturnItems = () => {
        this.setState({ returnItems: [] });
    };

    handleCloseConfirmationWindow = () => {
        this.setState({ confirmationWindowOpen: false });
    };

    handleOpenConfirmationWindow = () => {
        this.setState({ confirmationWindowOpen: true });
    };

    handleRefreshOrder = () => {
        this.props.handleClose();
        this.props.refreshOrder();
    };

    getReturnItemSelectedQuantity = lineItem => {
        const item = this.state.returnItems.find(i => i.lineItemId === lineItem.line_item_id);
        return item ? item.quantity : 0;
    };

    render() {
        const { name, preorder } = this.props.order;

        const { total_line_items_price_formatted, total_discounts_formatted, total_shipping_formatted, total_tax_formatted, total_price_formatted } =
            this.props.returnOrderCalculateData;

        const {
            ORDER_PAGE: {
                RETURN_SECTION: { REFUND_SUMMARY, RETURN_ORDER, RETURN_ORDER_ITEMS },
                RETURN_SECTION
            },
            MISC,
            DATA_CONFLICT
        } = this.props.currentLanguage;

        return (
            <Dialog
                classes={{ paper: `popup-window-dialog-paper${this.state.returnFinished ? " completed" : ""}` }}
                className="popup-window-dialog"
                disableBackdropClick
                disableEscapeKeyDown
                open={this.props.open || false}
            >
                <div className={`layout vertical popup-window return-order-items-window relative${this.state.returnFinished ? " completed" : ""}`}>
                    <div className="flex layout horizontal end-justified">
                        <CloseIcon className="layout vertical center-center close-corner-button" onClick={this.handleNoClick} />
                    </div>
                    <div className="flex layout vertical popup-window-inner">
                        {(this.state.confirmationWindowOpen || this.state.dataConflictWindowOpen) && <div className="fit layout vertical backdrop-1" />}
                        {(this.props.loading || this.props.returnOrderCalculating || this.props.returnReasonsLoading) && (
                            <div className={`loading-box fit layout vertical center-center`}>
                                <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} />
                            </div>
                        )}
                        <div className="layout vertical header">
                            <p className="layout vertical center-center title">
                                <p className="title">{RETURN_ORDER_ITEMS.HEADING}</p>
                            </p>
                        </div>
                        {!this.state.returnFinished && (
                            <React.Fragment>
                                <div className="layout vertical body">
                                    {this.props.total_egift_cards !== null && this.props.total_egift_cards > 0 && (
                                        <div className="egiftcards-notice">{RETURN_ORDER.EGIFTCARDS_PRESENT_MESSAGE}</div>
                                    )}
                                    <p className="sub-title" style={{ margin: "0px 0px 5px" }}>
                                        {RETURN_ORDER_ITEMS.SUBHEADING}
                                    </p>
                                    <div className="flex layout dynamic-direction-mobile-landspace">
                                        <div className="flex layout vertical return-items-box">
                                            {_.orderBy(this.state.itemsAvailableForReturn, ["price"], ["desc"]).map((li, i) => {
                                                const availableQuantitySelectList = Array.from({ length: li.quantity + 1 }, (_, index) => index);
                                                const variantName = getFilteredLineItemVariant(li);
                                                const productName = getFilteredLineItemName(li, this.props.order);

                                                return (
                                                    <div key={i} className="layout horizontal list-item">
                                                        <div className="flex layout horizontal list-item-name-box center">
                                                            <div className="flex list-item-image-box relative">
                                                                <img
                                                                    className="list-item-image"
                                                                    src={getItemPicture(li.sku)}
                                                                    alt=""
                                                                    onError={e => (e.target.src = getFallbackItemPicture())}
                                                                />
                                                            </div>
                                                            <div className="layout vertical">
                                                                <span className="line-item-title">{productName}</span>
                                                                {variantName && <span className="line-item-variant-name">{variantName}</span>}
                                                                <span>{li.price_formatted || li.price}</span>
                                                            </div>
                                                        </div>
                                                        <div className="layout horizontal center list-item-quantity-box">
                                                            <Select
                                                                classes={{
                                                                    selectMenu: "custom-select-menu"
                                                                }}
                                                                name="return-item-quantity"
                                                                MenuProps={{
                                                                    variant: "menu",
                                                                    getContentAnchorEl: null,
                                                                    classes: {
                                                                        paper: "custom-select-menu-paper"
                                                                    }
                                                                }}
                                                                className="custom-select"
                                                                style={{ minWidth: "50px" }}
                                                                disabled={false}
                                                                value={this.getReturnItemSelectedQuantity(li)}
                                                                onChange={e => this.handleReturnItemQuantityChange(li, e)}
                                                            >
                                                                {availableQuantitySelectList.map((selectQuantity, i) => {
                                                                    return (
                                                                        <MenuItem key={i} className="form-menu-item-select-multiple" value={selectQuantity}>
                                                                            <ListItemText
                                                                                classes={{
                                                                                    root: "form-menu-item-select-multiple-list-item-text"
                                                                                }}
                                                                            >
                                                                                {selectQuantity}
                                                                            </ListItemText>
                                                                        </MenuItem>
                                                                    );
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>

                                        <div className="flex layout vertical">
                                            <div className="order-summary-container allow-focus">
                                                <h2 className="container-title">{REFUND_SUMMARY.HEADING}</h2>
                                                <div className="layout horizontal">
                                                    <div>{name}</div>
                                                    <div className="layout horizontal order-tags">{preorder && <div className="tag">{MISC.PREORDER}</div>}</div>
                                                </div>

                                                <div className="summary-divider"></div>
                                                <div className="summary-line-container">
                                                    <div className="summary-line-label">{REFUND_SUMMARY.ITEMS_SUBTOTAL_TITLE}:</div>
                                                    <div className="summary-line-value">{total_line_items_price_formatted || "-"}</div>
                                                </div>
                                                {this.props.returnOrderCalculateData && this.props.returnOrderCalculateData.total_discounts_formatted > 0 && (
                                                    <div className="summary-line-container">
                                                        <div className="summary-line-label">{REFUND_SUMMARY.DISCOUNT_TITLE}:</div>
                                                        <div className="summary-line-value">{total_discounts_formatted || "-"}</div>
                                                    </div>
                                                )}
                                                <div className="summary-line-container">
                                                    <div className="summary-line-label">{REFUND_SUMMARY.SHIPPING_TITLE}:</div>
                                                    <div className="summary-line-value">{total_shipping_formatted || "-"}</div>
                                                </div>
                                                <div className="summary-line-container">
                                                    <div className="summary-line-label">{REFUND_SUMMARY.TAXES_TITLE}:</div>
                                                    <div className="summary-line-value">{total_tax_formatted || "-"}</div>
                                                </div>
                                                <div className="summary-divider"></div>
                                                <div className="summary-line-container">
                                                    <div className="summary-line-label total">{REFUND_SUMMARY.REFUND_TOTAL_TITLE}:</div>
                                                    <div className="summary-line-value total">
                                                        <p className="total-price">{total_price_formatted || "-"}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="return-reason-box">
                                                <div className="layout vertical custom-select-box">
                                                    <InputLabel className="custom-select-label">* {RETURN_SECTION.REASON_HEADER}</InputLabel>
                                                    <Select
                                                        classes={{
                                                            selectMenu: "custom-select-menu"
                                                        }}
                                                        name="return-reason"
                                                        MenuProps={{
                                                            variant: "menu",
                                                            getContentAnchorEl: null,
                                                            classes: {
                                                                paper: "custom-select-menu-paper"
                                                            }
                                                        }}
                                                        className="custom-select"
                                                        disabled={false}
                                                        value={this.state.returnReasonId || -1}
                                                        onChange={this.handleChange}
                                                    >
                                                        {this.props.returnReasons &&
                                                            this.props.returnReasons.length > 0 &&
                                                            this.props.returnReasons.map((returnReason, i) => {
                                                                return (
                                                                    <MenuItem key={i} className="form-menu-item-select-multiple" value={returnReason.id}>
                                                                        <ListItemText
                                                                            classes={{
                                                                                root: "form-menu-item-select-multiple-list-item-text"
                                                                            }}
                                                                        >
                                                                            {RETURN_SECTION.REASONS[returnReason.code]}
                                                                        </ListItemText>
                                                                    </MenuItem>
                                                                );
                                                            })}
                                                        )
                                                    </Select>
                                                    {this.state.submitErrors.length > 0 && this.state.submitErrors.find(e => e.code === "return_reason") && (
                                                        <FormHelperText>{this.state.submitErrors.find(e => e.code === "return_reason").label}</FormHelperText>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.submitErrors.length > 0 && this.state.submitErrors.find(e => e.code === "return_items") && (
                                        <FormHelperText className="custom-helper-text">
                                            {this.state.submitErrors.find(e => e.code === "return_items").label}
                                        </FormHelperText>
                                    )}
                                </div>

                                <div className="layout vertical footer">
                                    {this.state.returnErrorMessage && <div className="message-box">{this.state.returnErrorMessage}</div>}
                                    <div className="layout vertical buttons-box">
                                        <div className="flex layout dynamic-direction-mobile-portrait buttons">
                                            <button className="flex custom-button negative" onClick={this.handleNoClick}>
                                                <div className="layout vertical center-center inbutton-text">{MISC.CLOSE}</div>
                                            </button>
                                            <button
                                                className={`flex custom-button ${this.props.loading ? "loading" : ""}`}
                                                style={{ float: "right" }}
                                                onClick={this.props.loading ? null : this.handleYesClick}
                                            >
                                                <div className="layout vertical center-center inbutton-text">{MISC.SUBMIT}</div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                        {this.state.returnFinished && (
                            <React.Fragment>
                                <div className="layout vertical body">
                                    <div className="flex layout horizontal center-center">
                                        <Confirmed fill="#BF0000" />
                                        <p style={{ margin: "0px 10px" }}>{RETURN_ORDER_ITEMS.SUCCESS_MESSAGE}</p>
                                    </div>
                                </div>
                                <div className="layout vertical footer">
                                    <div className="flex layout dynamic-direction-mobile-portrait buttons">
                                        <button className="flex custom-button" onClick={this.handleNoClick}>
                                            <div className="layout vertical center-center inbutton-text">{MISC.CLOSE}</div>
                                        </button>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                        <ConfirmationWindow
                            open={this.state.confirmationWindowOpen}
                            handleClose={this.handleCloseConfirmationWindow}
                            handleSubmit={this.handleConfirmReturnOrder}
                            loading={this.props.loading}
                            heading={RETURN_ORDER_ITEMS.CONFIRMATION.HEADING}
                            subheading={RETURN_ORDER_ITEMS.CONFIRMATION.SUBHEADING}
                            noText={MISC.NO}
                            yesText={MISC.YES}
                        />
                        <DataConflictWindow
                            open={this.state.dataConflictWindowOpen}
                            handleSubmit={this.handleRefreshOrder}
                            heading={DATA_CONFLICT.HEADING}
                            subheading={DATA_CONFLICT.SUB_HEADING}
                            yesText={MISC.REFRESH}
                        />
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default withRouter(ReturnOrderItemsWindow);
